/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Create_Event_DeniedInputs */

const th_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`บทบาทของคุณ (${i?.role}) ไม่มีสิทธิ์สร้างรายการแข่งขัน`)
};

const en_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your role (${i?.role}) does not have permission to create events.`)
};

const ja_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あなたの役割（${i?.role}）には大会を作成する権限がありません。`)
};

const zh_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的角色（${i?.role}）不能创建赛事。`)
};

const es_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu rol (${i?.role}) no tiene permiso para crear eventos.`)
};

const pt_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seu perfil (${i?.role}) não tem permissão para criar eventos.`)
};

const id_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peran Anda (${i?.role}) tidak boleh membuat acara.`)
};

const fr_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre rôle (${i?.role}) n’a pas la permission de créer des événements.`)
};

const tl_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hindi maaaring gumawa ng event ang tungkulin mong ${i?.role}.`)
};

const vi_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vai trò ${i?.role} của bạn không được tạo sự kiện.`)
};

const ko_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.role} 역할로는 이벤트를 만들 수 없습니다.`)
};

const de_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Rolle (${i?.role}) darf keine Events anlegen.`)
};

const ru_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваша роль (${i?.role}) не может создавать события.`)
};

const tr_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.role} rolünüz etkinlik oluşturamaz.`)
};

const it_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il tuo ruolo (${i?.role}) non può creare eventi.`)
};

const pl_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Twoja rola (${i?.role}) nie może tworzyć wydarzeń.`)
};

const uk_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ваша роль (${i?.role}) не може створювати події.`)
};

const hi_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आपकी भूमिका (${i?.role}) आयोजन नहीं बना सकती।`)
};

const ar_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`دورك (${i?.role}) لا يسمح بإنشاء الفعاليات.`)
};

const ms_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peranan anda (${i?.role}) tidak boleh mencipta acara.`)
};

const bn_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`আপনার ভূমিকা (${i?.role}) আয়োজন তৈরি করতে পারে না।`)
};

const zh_tw2_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的角色（${i?.role}）無法建立賽事。`)
};

const zh_hk2_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`你的角色（${i?.role}）無法建立賽事。`)
};

const ur_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`آپ کا کردار (${i?.role}) ایونٹ نہیں بنا سکتا۔`)
};

const fa_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`نقش شما (${i?.role}) اجازهٔ ساختن رویداد ندارد.`)
};

const sw_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nafasi yako (${i?.role}) haiwezi kufungua matukio.`)
};

const nl_create_event_denied = /** @type {(inputs: Create_Event_DeniedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je rol (${i?.role}) mag geen evenementen aanmaken.`)
};

/**
* | output |
* | --- |
* | "Your role ({role}) does not have permission to create events." |
*
* @param {Create_Event_DeniedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const create_event_denied = /** @type {((inputs: Create_Event_DeniedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Event_DeniedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_create_event_denied(inputs)
	if (locale === "ja") return ja_create_event_denied(inputs)
	if (locale === "zh") return zh_create_event_denied(inputs)
	if (locale === "es") return es_create_event_denied(inputs)
	if (locale === "pt") return pt_create_event_denied(inputs)
	if (locale === "id") return id_create_event_denied(inputs)
	if (locale === "fr") return fr_create_event_denied(inputs)
	if (locale === "tl") return tl_create_event_denied(inputs)
	if (locale === "vi") return vi_create_event_denied(inputs)
	if (locale === "ko") return ko_create_event_denied(inputs)
	if (locale === "de") return de_create_event_denied(inputs)
	if (locale === "ru") return ru_create_event_denied(inputs)
	if (locale === "tr") return tr_create_event_denied(inputs)
	if (locale === "it") return it_create_event_denied(inputs)
	if (locale === "pl") return pl_create_event_denied(inputs)
	if (locale === "uk") return uk_create_event_denied(inputs)
	if (locale === "hi") return hi_create_event_denied(inputs)
	if (locale === "ar") return ar_create_event_denied(inputs)
	if (locale === "ms") return ms_create_event_denied(inputs)
	if (locale === "bn") return bn_create_event_denied(inputs)
	if (locale === "zh-TW") return zh_tw2_create_event_denied(inputs)
	if (locale === "zh-HK") return zh_hk2_create_event_denied(inputs)
	if (locale === "ur") return ur_create_event_denied(inputs)
	if (locale === "fa") return fa_create_event_denied(inputs)
	if (locale === "sw") return sw_create_event_denied(inputs)
	if (locale === "nl") return nl_create_event_denied(inputs)
	return en_create_event_denied(inputs)
});